<template>
  <v-sheet v-if="showUploadForm" outlined shaped class="pa-md-5 my-5">
    <ValidationObserver ref="obs">
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12" md="6">
                  <ValidationProvider name="نوع مدرک" rules="required">
                    <v-select
                      slot-scope="{ errors }"
                      :error-messages="errors"
                      label="نوع مدرک"
                      outlined
                      item-text="value"
                      item-value="id"
                      v-model="file.documentTypeId"
                      dense
                      :items="merchantDocumentTypes"
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6">
                  <ValidationProvider name="تاریخ انقضاء" rules="">
                    <div>
                      <date-picker
                        format="YYYY-MM-DD"
                        display-format="jYYYY-jMM-jDD"
                        ref="reserveDateUtc"
                        required
                        v-model="file.expirationDateUtc"
                        class="datep"
                        :initial-value="addMonthToDate(6)"
                        :min="addMonthToDate(3)"
                        simple
                      >
                        <div slot="label">
                          <span for="" class="m-0">تاریخ انقضاء</span>
                        </div>
                      </date-picker>
                    </div>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="file.description"
                    label="توضیحات"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="5" class="mr-md-auto">
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    ref="file"
                    name="فایل"
                    rules="required|ext:jpg,png,jpeg,pdf,doc|size:2000"
                  >
                    <v-file-input
                      style="direction: ltr"
                      slot-scope="{ errors }"
                      :error-messages="errors"
                      label="فایل"
                      outlined
                      show-size
                      :clearable="false"
                      dense
                      v-model="fileId"
                      @change="uploadFile($event)"
                    ></v-file-input>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12">
                  <v-sheet color="grey lighten-3" rounded>
                    <v-container>
                      <v-col>
                        <div>
                          <div class="mb-1">شرایط فایل</div>
                          <ul style="margin-right: 1rem">
                            <li>صاف و به همراه نوشته های واضح</li>
                            <li>حجم زیر دو مگابایت</li>
                          </ul>
                        </div>
                      </v-col>
                    </v-container>
                  </v-sheet>
                </v-col>
                <v-col cols="12">
                  <v-btn color="blue" dark @click="uploadDocument()">
                    آپلود مدرک
                    <v-icon right> mdi-cloud-upload </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </ValidationObserver>
  </v-sheet>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import { mapGetters } from 'vuex';
const filesRepository = () => RepoFactory.get('files');
import reusableMethodsMixin from "@/core/mixins/reusableMethodsMixin";


export default {
  name: 'BusinessInformationUploadDocForm',
  props: {
    showUploadForm: {
      type: Boolean,
      default: false,
    },
    merchantDocumentTypes: {
      type: Array,
      default: [],
    },
  },
  mixins: [reusableMethodsMixin],
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      fileId: null,
      loader: null,
      file: {
        documentTypeId: null,
        fileId: null,
        description: null,
        expirationDateUtc: null,
      },
    };
  },
  created() {
     this.file.expirationDateUtc = this.addMonthToDate(6)
  },
  computed: {
    ...mapGetters(['fileBaseUrl']),
    oneMonthLater() {
      let date = new Date();
      date.setMonth(date.getMonth() + 1);
      return date;
    },
  },
  methods: {
    async uploadFile(file) {
      const check = await this.$refs.file.validate();
      if (!check) {
        return false;
      }
      this.loader = this.$loading.show();
      let fil = new FormData();
      fil.append('file', file);
      filesRepository()
        .sendFileBySupplierAccess(fil, this.fileBaseUrl, {MerchantId :this.$store.getters.currentMerchant, Folder : 'Unspecified'})
        .then(({ data }) => {
          this.file.fileId = data.fileId;
        })
        .finally(() => this.loader.hide());
    },
    async uploadDocument() {
      const check = await this.$refs.obs.validate();
      if (!check) {
        return false;
      }
      this.$emit('uploadDocument', this.file);
    },
  },
};
</script>
